import { Container, Grid } from "@material-ui/core"
import HomePage from "../../Home"
import { useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { obtenerCalculoGruposClaveViajeAction, obtenerGruposClaveViajeAction } from "../../../ducks/liquidacionesDuck"
import TGrupoLiquidaciones from "../TGrupoLiquidaciones"
const VGrupoAereo = () => {
    const { ClavePaquete } = useParams()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerGruposClaveViajeAction({ claveViaje: ClavePaquete }))
        dispatch(obtenerCalculoGruposClaveViajeAction({ claveViaje: ClavePaquete }))
    }, [dispatch, ClavePaquete])
    return (
        <HomePage>
            <Container>
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Liquidaciones</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <TGrupoLiquidaciones />
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VGrupoAereo